import apiClient from '@/services/axios'

export const testing = async () => {
  try {
    const res = await apiClient("/dashboard/testing")
    return res.data
  } catch (e) {
    console.log('error when getting dashboard data with error: ' + e)
    return []
  }
  // const res = await apiClient("/dashboard/testing")
  // console.log(res)
}
